module.exports = {"classes":["jp-new-homepage-page","header-dark"],"title":"Single Sign On & Token Based Authentication","metas":{},"opengraph":{},"twittercard":{}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/jp/homepage/data/metadata.json
// module id = 1518
// module chunks = 0